import { render, staticRenderFns } from "./SemanticShiftTable.vue?vue&type=template&id=682058ca"
import script from "./SemanticShiftTable.vue?vue&type=script&lang=js"
export * from "./SemanticShiftTable.vue?vue&type=script&lang=js"
import style0 from "./SemanticShiftTable.vue?vue&type=style&index=0&id=682058ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports